import React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */
        "@omni/components/components/Calculator/StabilizedSandCalculator/stabilizedSandCalculator.container"
    ).then((module) => ({
        default: module.StabilizedsandCalculator
    }))
);
